import AgreementViewPage from './AgreementView.page';

export default AgreementViewPage;
